module.exports = __webpack_public_path__ + "static/media/logo-dark.b338c7af.svg";